module.exports = __webpack_public_path__ + "static/8-f679e4515056c6cf4dd7669c28b2b0f0.wav";